<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">
          <span> Test Package Group <i class="fa fa-minus" /> </span>
          <span> {{ test_package_group.name }} <i class="fa fa-minus" /> </span>
        </span>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="2">Name</b-col>
          <b-col>{{ test_package_group.name }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2">Sample Type</b-col>
          <b-col>
            <a
              v-if="test_package_group.sample_type"
              :href="`#/sampletypes/${test_package_group.sample_type_id}`"
            >
              {{ test_package_group.sample_type.name }}
            </a>
            <span v-else>Not specified</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <template v-if="test_package_group.test_packages.length">
      <label class="font-weight-bold h3">Test Packages</label>
      <v-client-table
        title="Test Packages"
        :columns="columns"
        :data="test_package_group.test_packages"
        :options="options"
        :theme="theme"
        id="test-packages-table"
        class="w-100"
      >
        <span slot="package_name" slot-scope="{ row }">
          <a :href="`#/testpackages/${row.id}`">
            {{ row.name }}
          </a>
        </span>
        <span slot="package_cost" slot-scope="{ row }">
          {{ row.cost ? `${row.cost}$` : "Not specified" }}
        </span>
        <span slot="package_samples_quantity" slot-scope="{ row }">
          {{ row.test_package_samples.length }}
        </span>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "TestPackageGroupCard",
  components: { ClientTable },
  props: {
    test_package_group: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      columns: ["package_name", "package_cost", "package_samples_quantity"],
      options: {
        filterable: false
      },
      theme: "bootstrap4",
      template: "default"
    };
  }
};
</script>
